// extracted by mini-css-extract-plugin
export var title = "video-slide-module--title--3ed6a";
export var wrapperHorizontal = "video-slide-module--wrapperHorizontal--23cee";
export var wrapperVertical = "video-slide-module--wrapperVertical--6a81f";
export var wrapperVideo = "video-slide-module--wrapperVideo--1a964";